export default __webpack_public_path__ + "static/media/Remediation_History.e15bc86f.svg";